// Set the language to English.
document.cookie = "preferred_language=en";
